var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"imgs-container"},_vm._l((_vm.imgs),function(img,index){return _c('img',{key:img,attrs:{"src":img},on:{"click":function($event){return _vm.handleImgsClick(index)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }